<template>
  <div>
        <template v-if="skeletonLoader">
          <v-skeleton-loader type="table-heading, table-thead, table-tbody@2, table-tfoot"> </v-skeleton-loader>
        </template>
        <template v-else>
          <!-- tabla -->
          <v-card>
            <v-card-title class="text-h5 font-weight-bold primary--text">
              <v-row>
                <v-col
                  cols="12"
                  sm="9"
                >
                  Gestionar Habilidades
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-if="habilidades.length > 0"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    label="Buscar Habilidad"
                    hide-details
                    v-model="searchTable"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-title>

            <v-data-table
              fixed-header
              height="calc(100vh - 220px)"
              class="elevation-2"
              :headers="headersTable"
              :search="searchTable"
              :items="habilidades"
              :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
            >
              <template v-slot:[`item.acciones`]="{ item }">
                <v-tooltip 
                  v-for="accion in accionesModulo"
                  :key="accion.id_modulo"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      class="ml-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="ejecutarAcciones(accion.accion, item.id)"
                    >
                      {{ accion.icono }}
                    </v-icon>
                  </template>
                  <span>{{ accion.modulo }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    headersTable: [
      {
        text: "Codigo",
        value: "codigo_habilidad",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Habilidad",
        value: "categoria",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],
  }),

  mounted() {
    this.$store.dispatch("gestionarHabilidades");
    this.$store.dispatch("gestionarExpertosNacionales", 0);

    setTimeout(() => {
        this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    accionesModulo() {
      const modulo = this.$store.getters.obtenerAccionesModulo.find(modulo => modulo.id_modulo == 64)
      const acciones = modulo.hijos.filter(modulo => modulo.accion !== null)
      return acciones;
    },

    usuario() {
      return this.$store.getters.usuario;
    },

    expertoNacional() {
      return this.$store.getters.obtenerExpertoNacionalIdentificacion(this.usuario.identificacion);
    },

    habilidades() {
      if (this.expertoNacional != null) {
        return this.$store.getters.obtenerHabilidadExpertoNacional(this.expertoNacional.categoria_id);
      }
      return this.$store.getters.obtenerHabilidades
    },
  },

  methods: {
    ejecutarAcciones(accion, id) {
      this[accion](id)
    },
    detalles(habilidad) {
      this.$router.push({
        name: "habilidad-detalles",
        params: { id_habilidad: habilidad },
      });
    },

    actualizar(habilidad) {
      this.$router.push({
        name: "habilidad-actualizar",
        params: { id_habilidad: habilidad },
      });
    },

    gestionarDocumentos(habilidad) {
      this.$router.push({
        name: "habilidad-documentos",
        params: { id_habilidad: habilidad },
      });
    },
  },
};
</script>
